export default function PlanImpressionPrixConfiguration($translatePartialLoaderProvider) {
    $translatePartialLoaderProvider.addPart('plan.impression.prix');
}

PlanImpressionPrixConfiguration.$inject = ['$translatePartialLoaderProvider'];
